export default __webpack_public_path__ + "static/media/Icon_material-add-circle-outline.f4d26232.svg";